export const randomString = () => Math.random().toString(36).substring(7);

export const uuidV4Validation = (id: string) => {
  const uuidV4Regex = new RegExp(/^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i);

  return id.match(uuidV4Regex);
};
